import axiosInstance from "../plugins/axios";

export function userManagementService() {
  const searchUser = async data => {

    let url = '?';
    if(data){
      for (const [key, value] of Object.entries(data)) {
        if(value){
          url += `${key}=${value}&`
        }
      }
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/users/${url}`
    );
  };

  const changeStatus = async data => {
    return await axiosInstance.put(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/user-state/${data.id}`,
      {state:data.state}
    );
  };

  const makeUserAdmin = async data => {
    return await axiosInstance.put(
      `${process.env.VUE_APP_BASE_URL_SUPER_ADMIN}/make-admin/${data.id}`
    );
  };
  const makeUserNormal = async data => {
    return await axiosInstance.put(
      `${process.env.VUE_APP_BASE_URL_SUPER_ADMIN}/make-normal/${data.id}`
    );
  };

  const fetchUserProfile = async data => {
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/user/${data.id}`,
    );
  };
  const editUserProfile = async data => {
    return await axiosInstance.put(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/edit-user/${data.id}`,
      data.data
    );
  };
  return {
    searchUser,
    changeStatus,
    makeUserAdmin,
    makeUserNormal,
    fetchUserProfile,
    editUserProfile,

  };
}
